var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStandings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 14.486598,41.750561 c 9.755886,0 19.511769,0 29.564286,0 0,1.466667 0,2.937454 0,4.449439 -9.755884,0 -19.51177,0 -29.564286,0 0,-1.466666 0,-2.937453 0,-4.449439 z m 0,0",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 14.486598,31.862921 c 9.755886,0 19.511769,0 29.564286,0 0,1.466668 0,2.937454 0,4.449439 -9.755884,0 -19.51177,0 -29.564286,0 0,-1.466667 0,-2.937453 0,-4.449439 z m 0,0",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 14.486598,21.975281 c 9.755886,0 19.511769,0 29.564286,0 0,1.466667 0,2.937454 0,4.449438 -9.755884,0 -19.51177,0 -29.564286,0 0,-1.466667 0,-2.937454 0,-4.449438 z m 0,0",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 14.486598,12.08764 c 9.755886,0 19.511769,0 29.564286,0 0,1.466667 0,2.937453 0,4.449439 -9.755884,0 -19.51177,0 -29.564286,0 0,-1.466668 0,-2.937454 0,-4.449439 z m 0,0",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 14.486598,2.2 c 9.755886,0 19.511769,0 29.564286,0 0,1.4666666 0,2.9374529 0,4.4494382 -9.755884,0 -19.51177,0 -29.564286,0 0,-1.4666666 0,-2.9374529 0,-4.4494382 z m 0,0",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 4.5,41.750561 c 1.8292284,0 3.654337,0 5.537124,0 0,1.466667 0,2.937454 0,4.449439 -1.8292287,0 -3.6543373,0 -5.537124,0 0,-1.466666 0,-2.937453 0,-4.449439 z m 0,0",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 4.5,31.862921 c 1.8292284,0 3.654337,0 5.537124,0 0,1.466668 0,2.937454 0,4.449439 -1.8292287,0 -3.6543373,0 -5.537124,0 0,-1.466667 0,-2.937453 0,-4.449439 z m 0,0",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 4.5,21.975281 c 1.8292284,0 3.654337,0 5.537124,0 0,1.466667 0,2.937454 0,4.449438 -1.8292287,0 -3.6543373,0 -5.537124,0 0,-1.466667 0,-2.937454 0,-4.449438 z m 0,0",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m 4.5,12.08764 c 1.8292284,0 3.654337,0 5.537124,0 0,1.466667 0,2.937453 0,4.449439 -1.8292287,0 -3.6543373,0 -5.537124,0 0,-1.466668 0,-2.937454 0,-4.449439 z m 0,0",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m 4.5,2.2 c 1.8292284,0 3.654337,0 5.537124,0 0,1.4666666 0,2.9374529 0,4.4494382 -1.8292287,0 -3.6543373,0 -5.537124,0 C 4.5,5.1827716 4.5,3.7119853 4.5,2.2 Z m 0,0",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStandings);
export default __webpack_public_path__ + "static/media/menu_standings.3a5b3322a875ba7945594c849f546efd.svg";
export { ForwardRef as ReactComponent };